export class ExpressionsController {
  constructor() {
    this._params_by_id = /* @__PURE__ */ new Map();
  }
  registerParam(param) {
    this._params_by_id.set(param.graphNodeId(), param);
  }
  deregisterParam(param) {
    this._params_by_id.delete(param.graphNodeId());
  }
  regenerateReferringExpressions(node) {
    node.nameController.graph_node.setSuccessorsDirty(node);
  }
}
